module.exports = __webpack_public_path__ + "static/pic01-e1e139d897571aa90043e65bed8ff97b.jpg";